module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("WELCOME TO QO’NOS")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Hem tlhIngan Segh ‘ej maHemtaH ‘e’ wIHech.”")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("(“Klingons are a proud race, and we intend to go on being proud.”)")])]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("—Azetbur, Chancellor to the Klingon High Council, 2293")])])]), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev01"
    }
  }, [_vm._v("GETTING HERE")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev02"
    }
  }, [_vm._v("USING THIS GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev03"
    }
  }, [_vm._v("TIPS FOR A FUN TRIP")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev04"
    }
  }, [_vm._v("WHAT TO WEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev05"
    }
  }, [_vm._v("LODGING TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01aa#ch01lev06"
    }
  }, [_vm._v("ETIQUETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE KLINGON EMPIRE: A BRIEF HISTORY FOR VISITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early History, Early Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of Kahless the Unforgettable")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expansion and Conquest")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact with Earth and the Federation")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub01#ch01lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Empire Today")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01sub02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("tlhIngan Hol!")]), _vm._v(" DO YOU SPEAK IT?: A KLINGON LANGUAGE PRIMER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47575d8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01a.vue
// module id = 69
// module chunks = 0